import { SelectionItemImpl } from '../select/select.component';

export class AutoCompleteSelectionItem<TData = any> extends SelectionItemImpl<string> {
  constructor(name: string, value: string | null, data: TData, shortName?: string) {
    super(name, value);
    this.data = data;
    this.shortName = shortName ? shortName : name;
  }
  public readonly shortName: string;
  public readonly data: TData;
}
